'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _InputField = require('./InputField');

var _InputField2 = _interopRequireDefault(_InputField);

var _InputAffix = require('./InputAffix');

var _InputAffix2 = _interopRequireDefault(_InputAffix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputInset = function InputInset(props) {
    var insetLeft = props.insetLeft,
        insetRight = props.insetRight,
        isAffix = props.isAffix;

    var insetClassNames = (0, _classnames2.default)('luna-inset', {
        'luna-inset--left': insetLeft,
        'luna-inset--right': insetRight
    });
    return _react2.default.createElement("div", { className: insetClassNames }, isAffix ? _react2.default.createElement(_InputAffix2.default, Object.assign({}, props)) : _react2.default.createElement(_InputField2.default, Object.assign({}, props)), insetLeft || insetRight);
};
InputInset.propTypes = {
    insetLeft: _propTypes2.default.node.isRequired,
    insetRight: _propTypes2.default.node.isRequired,
    isAffix: _propTypes2.default.bool.isRequired
};
exports.default = InputInset;
//# sourceMappingURL=InputInset.js.map